import { render, staticRenderFns } from "./UpdatePspType.vue?vue&type=template&id=27cabf29&"
import script from "./UpdatePspType.vue?vue&type=script&lang=js&"
export * from "./UpdatePspType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports